import { Decimal } from 'decimal.js'

const decimalMax = (d, e) => {
  let c = d.comparedTo(e);
  if (c == -1) {
    return e;
  } else if (c == 1) {
    return d;
  } else {
    return d; // redundant
  }
};

const toFixed = s => new Decimal(s).toFixed(2);

const decimalSum = l => l.reduce((a, b) => a.add(b), new Decimal(0));

const coDecimalSum = l =>
  l.reduce((a, b) => a.add(new Decimal(b)), new Decimal(0));

export {
  toFixed,
  decimalMax,
  decimalSum,
  coDecimalSum
}
